import { render } from "./HelpSupportList.vue?vue&type=template&id=5555e98d"
import script from "./HelpSupportList.vue?vue&type=script&lang=js"
export * from "./HelpSupportList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__